<template>
  <VPLoadingSpinner
    :loading="loading"
    class="fixed w-full h-full"
  >
    <div class="mt-24">
      <RouterView />
    </div>
    <SideModal />
  </VPLoadingSpinner>
</template>

<script setup lang="ts">
import SideModal from '@/components/SideModal.vue';
import { VPLoadingSpinner } from '@vp/vue-components';
import { onMounted, ref } from 'vue';
import { useRootStore } from '@/stores/root';
import { useAccountStore } from '@/stores/account';

const loading = ref(false);
const rootStore = useRootStore();
const accountStore = useAccountStore();

onMounted(async () => {
  try {
    loading.value = true;
    await rootStore.loadConfig();
    await accountStore.loadAccountConfig();
  } finally {
    loading.value = false;
  }
});
</script>
